import React from "react";
import { SegmentButton, SegmentContainer, SegmentKicker, SegmentStatCard, SegmentStatLabel, SegmentStatsGrid, SegmentStatValue, SegmentText, SegmentTitle, SegmentWrapper } from "./segment.styles";

const Segment = () => {
  const storyStats = [
    { value: "30+", label: "Vehicles In Fleet" },
    { value: "1993", label: "Origins In Haulage" },
    { value: "2013", label: "Inert Recycling Established" },
    { value: "South Coast", label: "Primary Service Area" },
  ];

  return (
    <SegmentContainer>
      <SegmentWrapper>
        <SegmentKicker>Built on decades of experience</SegmentKicker>
        <SegmentTitle>Our Story</SegmentTitle>
        <SegmentText>
          What began as a dependable local haulage operation in 1993 has grown into Inert Recycling (UK) Limited, established in 2013 and trusted across Hampshire, West Sussex, and surrounding areas. Today, from our Highbridge Estates base in Eastleigh, we support projects of all sizes with proven
          transport, plant, and restoration capability.
        </SegmentText>
        <SegmentStatsGrid>
          {storyStats.map((item) => (
            <SegmentStatCard key={item.label}>
              <SegmentStatValue>{item.value}</SegmentStatValue>
              <SegmentStatLabel>{item.label}</SegmentStatLabel>
            </SegmentStatCard>
          ))}
        </SegmentStatsGrid>
        <SegmentButton href="/about">Read more</SegmentButton>
      </SegmentWrapper>
    </SegmentContainer>
  );
};

export default Segment;
